"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDJSONOption = void 0;
var TDJSONOption = /** @class */ (function () {
    function TDJSONOption() {
        this.KEY_ID = "$id";
        this.KEY_TYPE = "$type";
        this.deliminatorKey = ":";
        this.deliminatorValue = ",";
        this.deliminatorObjectStart = "{";
        this.deliminatorObjectEnd = "}";
        this.deliminatorArrayStart = "[";
        this.deliminatorArrayEnd = "]";
    }
    return TDJSONOption;
}());
exports.TDJSONOption = TDJSONOption;
//# sourceMappingURL=TDJSONOption.js.map